import { Icon, IconNames } from "@jobber/components/Icon";

export type StatusVariant = "success" | "critical" | "warning";

const STATUS_BG_COLOR: Record<StatusVariant, string> = {
    success: "var(--color-success)",
    critical: "var(--color-critical)",
    warning: "var(--color-warning)",
};

interface StatusTitleProps {
    readonly text: string;
    readonly iconName: IconNames;
    readonly variant: StatusVariant;
}

/** Heading text with an inline filled-circle status icon to its right. */
function StatusTitle({ text, iconName, variant }: StatusTitleProps) {
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "var(--space-small)",
            }}
        >
            {text}
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    backgroundColor: STATUS_BG_COLOR[variant],
                    flexShrink: 0,
                }}
            >
                <Icon name={iconName} customColor="#FFFFFF" />
            </span>
        </span>
    );
}

export default StatusTitle;
